import {
  CardBackBrownImg,
  CardBackGold,
  CardFrameGold,
  CardFrontBrownImg
} from "@/assets"
import { CARD_SKIN_TYPES, ICardBack } from "@/store/apis/cardBacksAPI"
import { ICardViewSkin } from "./types"

export const DEFAULT_CARD_VIEW_SKIN: Required<ICardViewSkin> = {
  backImgSrc: CardBackBrownImg,
  frontImgSrc: CardFrontBrownImg,
  colorBg: "#DFCFB2",
  colorBgShadow: "#DFCFB2",
  colorDescription: "#462507",
  colorTitle: "#462507",
  type: CARD_SKIN_TYPES.ORIGINAL
}

export const getCardViewSkin = (
  skin?: ICardViewSkin | null
): Required<ICardViewSkin> => {
  return {
    ...DEFAULT_CARD_VIEW_SKIN,
    ...skin
  }
}

export const cardSkinGold: ICardBack = {
  _id: "",
  createdAt: "",
  updatedAt: "",

  backImgSrc: CardBackGold,
  frontImgSrc: CardFrameGold,
  exampleImgSrc: CardFrontBrownImg,
  type: CARD_SKIN_TYPES.GOLD,
  colorBg: "#DFCFB2",
  colorBgShadow: "#CDBB9D",
  colorDescription: "#462507",
  colorTitle: "#462507"
}
